import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Row, Col, Collapse } from "reactstrap"
import { Link } from "react-router-dom"
import withRouter from "../Common/withRouter"
import classname from "classnames"

//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"

const Navbar = props => {
  const [report, setReport] = useState(false)
  const [app, setapp] = useState(false)

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="topnav">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                {/* <li className="nav-item">
                  <Link className="nav-link" to="/dashboard">
                    <i className="uil-home-alt me-2"></i> {props.t("Dashboard")}
                  </Link>
                </li> */}

                <li className="nav-item dropdown">
                  <Link
                  to="/allbookings"
                    // onClick={e => {
                    //   e.preventDefault()
                    //   setapp(!app)
                    // }}
                    className="nav-link dropdown-togglez arrow-none"
                  >
                   <i className="uil-home-alt me-2"></i>
                    Bookings 
                  </Link>
                  {/* <div className={classname("dropdown-menu", { show: app })}>
                    <Link to="/allbookings" className="dropdown-item">
                      All Bookings
                    </Link>
                
                  </div> */}
                </li>
                <li className="nav-item dropdown">
                  <Link
                   to="/add-new-booking"
                
                    className="nav-link dropdown-togglez arrow-none"
                  >
                    <i className="uil-apps me-2"></i>
                    Add New Booking 
                  </Link>
                 
                </li>

                <li className="nav-item dropdown">
                  <Link
                    to="/#"
                    // onClick={e => {
                    //   e.preventDefault()
                    //   setReport(!report)
                    // }}
                    className="nav-link dropdown-togglez arrow-none"
                  >
                    <i className="uil-apps me-2"></i>
                    Reports <div className="arrow-down"></div>
                  </Link>
                  <div className={classname("dropdown-menu", { show: report })}>
                    <Link to="#" className="dropdown-item">
                      My Bookings
                    </Link>
                    <Link to="#" className="dropdown-item">
                      Voucher Report
                    </Link>
                  </div>
                </li>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
